export const DATE_TIME_FORMAT = "YYYY-MM-DD HH:mm";
export const DATE_TIME_FULL_FORMAT = "YYYY-MM-DD HH:mm:ss";
export const DATE_TIME_READABLE_FORMAT = "MMM Do, HH:mm";
export const DATE_FORMAT = "YYYY-MM-DD";
export const DATE_READABLE_FORMAT = "MMM Do";
export const DATE_FULL_READABLE_FORMAT = "MMM Do YYYY";
export const TIME_FORMAT = "HH:mm";

export const TOOLTIP_TIMEOUT = 2000;
